import { faFileInvoice } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { FC } from 'react';
interface BillingActionProps {
  onManualBilling: () => void;
  isDisabled: boolean;
}
const BillingAction: FC<BillingActionProps> = ({ onManualBilling, isDisabled }) => {
  

  return (
    <div
      onClick={() => {
        if (isDisabled) return;
        onManualBilling();
      }}
      style={{
        color: isDisabled ? '#9ca3af' : '#FF9C00',
        border: `2px solid ${isDisabled ? '#9ca3af' : '#FF9C00'}`,
        borderRadius: '50%',
        width: '28px',
        height: '28px',
        backgroundColor: 'transparent',
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        fontSize: '18px',
        opacity: isDisabled ? 0.6 : 1
      }}
      onMouseEnter={(e) => {
        if (isDisabled) return;
        e.currentTarget.style.color = '#f0fdf4';
        e.currentTarget.style.borderColor = '#E06900';
        e.currentTarget.style.backgroundColor = '#E06900';
      }}
      onMouseLeave={(e) => {
        if (isDisabled) return;
        e.currentTarget.style.color = '#FF9C00';
        e.currentTarget.style.borderColor = '#FF9C00';
        e.currentTarget.style.backgroundColor = 'transparent';
      }}
      aria-disabled={isDisabled}
      title={isDisabled ? 'Seleccione viajes para facturar' : 'Cargar Factura'}
    >
      <FontAwesomeIcon icon={faFileInvoice} />
    </div>
  );
};

export default BillingAction;
